export const checklistFieldsPlaceholders = [
    {
        pID: 'name',
        placeholder: 'Add a product name here...',
    },
    {
        pID: 'details',
        placeholder: 'Add a product description here...',
    },
];

export const addititonalDisabledChecklistFields = [
    {
        pID: 'p5541',
        condition: null,
    },
    {
        pID: 'p110207',
        condition: null,
    },
    {
        pID: 'p55590',
        condition: null,
    },
    {
        pID: 'p90591',
        condition: null,
    },
    {
        pID: 'p111592',
        condition: null,
    },
    {
        pID: 'p111600',
        condition: null,
    },
    {
        pID: 'p10622',
        condition: null,
    },
    {
        pID: 'price',
        condition: { isRoltekUG: true, UGs: ['1', '2', '3', '4'] },
    },
];
